const tabItems = document.querySelectorAll('.p-tab-item');

tabItems.forEach((tab) => {
    tab.addEventListener('click', (event) => {
        const tabHead = event.target.closest('.js-tab-head');
        if (tabHead && tab.contains(tabHead)) {
            const pTabHead = tab.querySelector('.p-tab-head');
            pTabHead.scrollIntoView({ behavior: 'smooth', block: 'center' });

            const tabContent = tab.querySelector('.p-tab--content');

            if (tab.classList.contains('active')) {
                tab.classList.remove('active');
                tabContent.style.height = '0';
                tabContent.style.opacity = '0';
            } else {
                tabItems.forEach((item) => {
                    item.classList.remove('active');
                    const content = item.querySelector('.p-tab--content');
                    content.style.height = '0';
                    content.style.opacity = '0';
                });

                tab.classList.add('active');
                const contentHeight = tabContent.scrollHeight;
                tabContent.style.height = contentHeight + 'px';
                tabContent.style.opacity = '1';
            }
        }
    });
});

// Open the first tab by default on load (no scroll, just expand it).
const firstTab = tabItems[0];
if (firstTab) {
    const firstContent = firstTab.querySelector('.p-tab--content');
    firstTab.classList.add('active');
    if (firstContent) {
        firstContent.style.height = firstContent.scrollHeight + 'px';
        firstContent.style.opacity = '1';
    }
}
